module.exports = __webpack_public_path__ + "img/US_CrushDPS_ua.7c1626bd.webp";